import { medicalPatient, medicalWaste, retailOffice, retailExhibition } from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import video from '@src/assets/images/solution/manufacturingSteel/video/rtlsVideo.mp4';

export default {
  desc: 'Trong các hoạt động sản xuất và phân phối của doanh nghiệp, quản lý hàng tồn kho đóng vai trò then chốt, đòi hỏi một hệ thống chính xác và hiệu quả. Đáp ứng nhu cầu này, thẻ RFID và NFC đã được sử dụng rộng rãi.',
  keywords: 'NFC, UWB, BLE, quản lý kho hàng, nfc, uwb, ble, quan ly kho hang.',
  ogSite: 'Quản lý kho hàng bằng UWB và BLE – Giải pháp thay thế cho thẻ NFC',
  title: 'Quản lý kho hàng bằng UWB và BLE – Giải pháp thay thế cho thẻ NFC',
  ogUrl: 'https://orbro.io/vi/blog/nfc-uwb-ble',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AK0iWDwxW_WSF_F7yNjIa07OkmVhKArBLWz8-_J1moJsQci7Ije4YbYRD5Oa0A3rsNOuVWMRMVKmnI6q7dJm894FnMM4irt8-NIgSx08LF7IIza4ONna0iwlNNedic3hlVYbDPl7746HMAAhJMopboCbqV9PlElgpHpCuSsWKAWobQKY1JrFwdltqWl5FsJqgC4DiIaxM9NUQNJHd4Tt2bOO1lPabNGc27n5QShIyfFcNuGdpozghgJAoszlfuiyD5CVSXKJOXYsfrj1Dhk0cbYrU_RHZfxcle6uATv2tw81Rq5eyY-OCCnNI9WQYLcp5PeiRUydm3S0Ba1eR0DQF-dHz8AvSGqnC2liVRiO-p1TSfr_dtXdAJcEDMSC1_zz2O2dksO3KqdbnvRkpDU-xKCqeel5YaHVAxFFOt19k4SHGVc493DTVSksZhLeWJPTBllKX8oc5zt5qErJMjPZWMUZ2iOr-geb_9fVyyuZogAAj-tFvkAF-mqBapjOwe_z2_8caQhLzg6vnNK3OSmDHQMOLUyZT22pB-OBf0QWVA-9wzMUyIo6BZbUXSj8n0bd6Hq72hFlNnNKwDe2aHoam2KguWNLfBx3PFqYkeO3fbdBRoc8vGkW_FcogVpvOusbERHosgwDP6T-foORllJuVUPjKZyx3CuilLxfRO-fo-4JF0yB8zqC-WZUHzpzyYTN5LZk0nln7wCJNPlMuRtxzJNq_4KrjorS6SdzMmpuYJog9QlrLImyeiR3wOLLvc2bklRyoEQ5T-DcDttw6dzFt1jFu8BjtXKIJ9KCc5PfIgl4XB2T5LshMXFDw7HU2qoFfYHvyQciti_HH59bUaP67x0KwbzAFSnMyP8edq6y4Wsvvhrl5cvYepph4sK7Dn5zkeP1Pv9qa5wNbYn--ZEAND3870LLFBqN5ttPfpxijnKszom0HGZG9G1EGUcU3GeMyAKg5Un-dXh7mWayLTFjU2UIBCRzpU5w509ZaRDokT94aFEyudm035LQQWLoRIV6TInKZ-LaBi6LNpXrykfPgmZb97nPCdULyDlhpp7oYwDLN7wgNy6b0-Wn5Tj9sl8qVTs1o_LrAT-8tl2UZ-uM9MPzHVKPmpPtnDymJklgsbMOp3TK45pIQ9voLx_ESS7YM1S2gw2ihX-Kvs3PqdKmxJ8y6LU8Op4OdaAeuWY1evq4apVEly7tAVqx7Gh5EiLl7PdZnpX1PiwLiz4WnDK0WLV_YOPYQlouBLWy7ojtfLu_C5UjgrjyKBg71KnsCv680b2sBcB-p2Wt6aD6IFtfAlT5J5nzg_cW01H3nwcRUKJdwKsVN-6_vVbyyBX8WGa4yR00BKZ0_scjPlWgID-43QPnz5X6P0IHyJUKtyUTiZM9a5gV7_Raq8rjHTOwYAR4r8je2xkZBJ_jSbV2Dk5yn6wEfK7XhzhLDCOrIoZdOCMhy-Qh610uh34OOtAoLyPBLfWcF_RXsMAGfz73LPe3WJx9YjYMPmRu-dvPHRiBlNrBU2OrvZN1lW3XYjKgGHTt7QlAKY2D5XpDjGA8NsfGVcpLghIXt-HCy32YCFiUdpQr5rq6mf7hfmJr=w1871-h1190',
  ogType: 'website',
  date: '2023-11-20',
  tag1: '#Nfc',
  tag2: '#Uwb',
  tag3: '#Ble',
  tag4: '#Quanlykhohang',
  text: [
    {
      head: '',
      subHead: '',
      desc: 'Trong các hoạt động sản xuất và phân phối của doanh nghiệp, quản lý hàng tồn kho đóng vai trò then chốt, đòi hỏi một hệ thống chính xác và hiệu quả. Đáp ứng nhu cầu này, thẻ RFID và NFC đã được sử dụng rộng rãi. Tuy nhiên, gần đây, sự xuất hiện của công nghệ UWB (Ultra-Wideband - Băng thông siêu rộng) và BLE (Bluetooth Low Energy - Bluetooth năng lượng thấp) đã mở ra khả năng cho các hệ thống quản lý hàng tồn kho tốt hơn. Đặc biệt, việc ứng dụng UWB và BLE để thay thế thẻ NFC đang thu hút sự chú ý.',
      dot: '',
    },
    {
      head: 'Đặc điểm của UWB và BLE',
      subHead: 'UWB (Ultra-Wideband)',
      desc: 'UWB là công nghệ truyền thông không dây sử dụng băng thông rất rộng, cho phép theo dõi vị trí với độ chính xác cao. Do cung cấp dữ liệu vị trí có độ chính xác cao, UWB thể hiện hiệu suất vượt trội trong việc theo dõi hàng tồn kho và xác định vị trí theo thời gian thực. Ngoài ra, công nghệ này cung cấp khả năng truyền thông ổn định đồng thời tránh được nhiễu đa đường, cho phép thu thập dữ liệu chính xác.',
      dot: '',
    },
    {
      head: '',
      subHead: 'BLE (Bluetooth Low Energy)',
      desc: 'BLE là công nghệ Bluetooth tiêu thụ năng lượng thấp, phù hợp cho việc truyền dữ liệu hiệu quả giữa các thiết bị tiêu thụ điện năng thấp. Thẻ BLE có kích thước nhỏ và tuổi thọ pin dài, cho phép xây dựng hệ thống theo dõi hàng tồn kho tiết kiệm năng lượng. Hơn nữa, BLE có tính tương thích cao với điện thoại thông minh nên rất tiện lợi khi sử dụng.',
      dot: '',
    },
    {
      head: 'Lợi ích của việc thay thế thẻ NFC',
      subHead: 'Theo dõi vị trí chính xác',
      desc: 'Công nghệ UWB cung cấp thông tin vị trí rất chính xác, do đó có thể xác định chính xác vị trí theo thời gian thực của hàng hóa trong kho hậu cần hoặc trên dây chuyền sản xuất. Điều này nâng cao độ chính xác của việc quản lý hàng tồn kho, đồng thời giảm thiểu tổn thất và sai sót hàng tồn kho.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Vận hành tiêu thụ điện năng thấp',
      desc: 'Đặc tính tiêu thụ điện năng thấp của BLE cho phép các thẻ hoạt động trong thời gian dài. Điều này mang lại ưu điểm là kéo dài chu kỳ thay pin và giảm chi phí bảo trì.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tính tương thích cao',
      desc: 'BLE được hỗ trợ mặc định trên nhiều thiết bị, do đó có thể dễ dàng tích hợp với cơ sở hạ tầng hiện có. Đặc biệt, khả năng tương thích với điện thoại thông minh mang lại sự tiện lợi trong việc theo dõi hàng tồn kho không dây.',
      dot: '',
    },
    {
      head: 'Phương án triển khai',
      subHead: 'Áp dụng thẻ UWB và BLE',
      desc: 'Thay thế các thẻ NFC hiện có bằng thẻ UWB và BLE là bước đầu tiên. Qua đó, có thể tận dụng được lợi ích của việc theo dõi vị trí chính xác và vận hành tiêu thụ điện năng thấp.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Xây dựng nền tảng dữ liệu',
      desc: 'Để quản lý hiệu quả dữ liệu thu thập từ UWB và BLE, cần có một nền tảng dữ liệu hiệu quả. Triển khai một nền tảng lưu trữ và phân tích dữ liệu dựa trên đám mây để cho phép xử lý và phân tích dữ liệu theo thời gian thực.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tích hợp hệ thống',
      desc: 'Tích hợp hệ thống quản lý hàng tồn kho sử dụng UWB và BLE vào các hệ thống hiện có. Thông qua đó, tất cả dữ liệu được tích hợp và quản lý tập trung, giúp nâng cao năng suất và hiệu quả.',
      dot: '',
    },
    {
      head: 'Lời kết',
      subHead: '',
      desc: 'Hệ thống quản lý hàng tồn kho ứng dụng UWB và BLE để thay thế thẻ NFC mang lại nhiều lợi ích đa dạng như độ chính xác, vận hành tiêu thụ điện năng thấp và tính tương thích cao. Thông qua việc áp dụng các công nghệ này, doanh nghiệp sẽ có thể xây dựng được một hệ thống quản lý hàng tồn kho thông minh và hiệu quả hơn. Trong tương lai, dự kiến sẽ có nhiều doanh nghiệp hơn nữa áp dụng những công nghệ đổi mới này để đảm bảo năng lực cạnh tranh. ',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: medicalPatient.thumb,
        data: 'medicalPatient',
        link: '/vi/enterprise/medical/patient',
      },
      {
        img: retailExhibition.thumb,
        data: 'retailExhibition',
        link: '/vi/enterprise/retail/exhibition',
      },
      {
        img: retailOffice.thumb,
        data: 'retailOffice',
        link: '/vi/enterprise/retail/office',
      },
    ],
  },
};
